export default __webpack_public_path__ + "static/media/time-extension-request.a389c327.png";